import { useNavigationManager, APP_VERSION } from '../../../core';
import { RevoltButton } from '../../../components/RevoltButton';
import { RevoltIcon, AppLikeButton, RevoltMagicButton } from '../../../components';
import { canShowRemixButton, canShowWorkspaceButton } from '../../../core/utils/appAccessUtils';
import './EmbedHeader.css';

export function EmbedHeader({
  app,
  appId,
  viewTotal = 0,
  appManager,
  onLikeToggle,
  onRefresh,
  onFullscreen,
  onRemix,
  onOpenWorkspace,
  onOpenSettings,
  isOwner,
  isAdmin,
  refreshDisabled
}) {
  const navigationManager = useNavigationManager();

  const handleLogoClick = async () => {
    await navigationManager.goHome();
  };

  const appTitle = app?.name || 'Untitled App';
  const appOwner = app?.ownerDisplayName || app?.ownerUsername || 'Unknown owner';

  // Remix logic for embed mode - owner/admin always see it; others only if allowRemixing
  const canRemix = canShowRemixButton(app, { isOwner, isAdmin });
  const canShowWorkspace = canShowWorkspaceButton({ isOwner, isAdmin });

  return (
    <header className="embed-header">
      <div className="embed-header-content">
        <div className="embed-header-left">
          <a href="/main" className="header-logo-container" data-navigation-button onClick={(e) => { e.preventDefault(); handleLogoClick(); }}>
            <img
              src="https://bluedrake42.nyc3.cdn.digitaloceanspaces.com/revolt-site/site-assets/logo/revolt-logo-small-transparent.png"
              alt="Revolt"
              className="header-logo-img"
            />
            <span className="header-logo-text">RevoltGPT.dev</span>
          </a>
          <div className="embed-version">
            {APP_VERSION}
          </div>
          <div className="embed-app-info">
            <div className="embed-app-title">{appTitle}</div>
            <div className="embed-app-owner">by {appOwner}</div>
          </div>
          <div className="embed-app-stats">
            <div className="embed-stat">
              <RevoltIcon name="eye" size="sm" />
              <span>{viewTotal}</span>
            </div>
            <AppLikeButton
              appId={appId}
              initialLikes={app?.likes || 0}
              initialLiked={app?.userLiked || false}
              manager={appManager}
              onToggle={onLikeToggle}
            />
          </div>
        </div>

        <div className="embed-header-center">
        </div>

        <div className="embed-header-right">
        <div className="embed-app-actions">
          {canRemix && (
            <RevoltMagicButton
              onClick={onRemix}
            >
              <RevoltIcon name="lucide:wand-sparkles" size="sm" />
              Remix
            </RevoltMagicButton>
          )}
          {canShowWorkspace && onOpenSettings && (
            <RevoltButton
              className="playspace-button"
              as="a"
              href={`/app-settings/${appId}`}
              data-navigation-button
              onClick={async (e) => {
                e.preventDefault();
                await onOpenSettings();
              }}
            >
              <i className="fa-solid fa-gear"></i> Settings
            </RevoltButton>
          )}
          {canShowWorkspace && onOpenWorkspace && (
            <RevoltButton
              className="playspace-button"
              as="a"
              href={`/workspace/${appId}`}
              data-navigation-button
              onClick={async (e) => {
                e.preventDefault();
                await onOpenWorkspace();
              }}
            >
              <i className="fa-solid fa-code"></i> Workspace
            </RevoltButton>
          )}
          <RevoltButton
            className="playspace-button"
            onClick={onRefresh}
            disabled={refreshDisabled}
          >
            <i className="fa-solid fa-rotate-right"></i> Refresh
          </RevoltButton>
            <RevoltButton
              className="playspace-button"
              onClick={onFullscreen}
            >
              <i className="fa-solid fa-expand"></i> Full Screen
            </RevoltButton>
          </div>
        </div>
      </div>
    </header>
  );
}
